<ng-container *ngIf="previewMode">
  <label
      soho-label
      class="preview-label"
      [required]="required$ | async"
      attr.for="{{id}}"
      lm-label
        [layoutField] = "field"
        [personalize]="personalize"
      lm-text-style [textStyle]="field?.label?.textStyle"
  >{{'PreviewNoEllipses'| translate}}</label>
  <div class="lm-compound-field code-block is-readonly"
      [ngStyle]="{'display': 'inline-block','width': 'calc(100% - 32px)'}"
      soho-alert
      attr.id="{{id}}"
  >
    <lm-paragraph
      #LMParagraph
        [layoutObject]="elements"
        [layoutInfo]="layoutInfo"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [parentIsCompoundField]="true"
        [parentCompoundFieldDisplayAsText]="displayAsText"
        [parentCompoundFieldDisplayOnly]="readOnly$ | async"
        [specFields]="specFields"
        [attr.bindId]="bindId"
        [placeHolder]="placeHolder"
        [model]="model"
        [lmParagraphLayoutInfo]="paragraphLayout"
        (fieldEvent)="onFieldEvent($event)"
        (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-paragraph>
  </div>
  <hr class="preview-separator"/>
</ng-container>
<ng-container *ngIf="!previewMode">
  <label
    soho-label
    class="no-colon"
    [required]="required$ | async"
    attr.for="{{id}}"
    lm-label
      [layoutField] = "field"
      [personalize]="personalize"
    lm-text-style [textStyle]="field?.label?.textStyle"
  >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>

  <div class="lm-compound-field-container code-block-container" attr.id="{{id}}">
    <ng-container [ngSwitch]="formType">
      <ng-container *ngSwitchCase="formDisplayType.SEARCH_FORM">
        <div class="lm-compound-field code-block input-style"
            [ngClass]="{'is-readonly': readOnly$ | async}"
            [ngStyle]="{'display': 'inline-block'}"
        >
          <lm-paragraph
              #LMParagraph
              [layoutObject]="elements"
              [layoutInfo]="layoutInfo"
              [lmColumnLayoutInfo]="lmColumnLayoutInfo"
              [parentIsCompoundField]="true"
              [parentCompoundFieldDisplayAsText]="displayAsText"
              [parentCompoundFieldDisplayOnly]="readOnly$ | async"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [model]="model"
              [attr.bindId]="bindId"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-paragraph>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div lm-field-options
          [hasContextMenu]="insertContextMenu"
          [ajaxCallbackFunction]="onBeforeContextMenuOpen"
          [contextMenuEventFunction]="contextMenuClicked">
          <!--Currently Soho isn't supporting changing the color of the outlining box for the compound field if
           there is an error. Right now we are going to handle it in this ngStyle, but need to investigate having
           the soho control handle it instead. -->
          <div class="lm-compound-field code-block"
            [ngClass]="{'is-readonly': readOnly$ | async, 'input-style': !displayAsText, 'is-active': memberFieldFocused}"
            [ngStyle]="{'display': 'inline-block', 'border-color': compoundFieldInError ? '#e84f4f' : null}"
            soho-alert
          >
            <lm-paragraph
              #LMParagraph
              [layoutObject]="elements"
              [layoutInfo]="layoutInfo"
              [lmColumnLayoutInfo]="lmColumnLayoutInfo"
              [parentIsCompoundField]="true"
              [parentCompoundFieldDisplayAsText]="displayAsText"
              [parentCompoundFieldDisplayOnly]="readOnly$ | async"
              [specFields]="specFields"
              [attr.bindId]="bindId"
              [placeHolder]="placeHolder"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
              (errorOnMemberField)="onMemberFieldError($event)"
            ></lm-paragraph>
          </div>
          <button *ngIf="showCompactDialogButton && !displayAsText"
              [attr.tabindex]="isInAccessibilityMode ? 0 : -1"
              soho-button="btn-icon"
              icon="launch"
              id="CompactForm"
              class="btn-icon lm-compound-field-helper-button"
              (click)="openCompactDialog($event)"
              soho-tooltip
              [content]="launchButtonTooltip"
          >
            <span class="audible">{{launchButtonTooltip}}</span>
          </button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
